import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCalendarEventDate,
  StyledDateDayMonth,
  StyledDayNumber,
  StyledMonth,
  StyledDayText,
  StyledDateRight,
  StyledDayNumberNoDesktop,
  StyledDragIcon
} from './styleDate';
import {
  StyledCalendarEvent,
  StyledCalendarEventNot,
  StyleIconNotEvent,
  StyledButtonToday,
  StyledListEvent,
  StyledListEventName,
  StyledListEventItem,
  StyledListEventHours
} from './style';
import { NotEvent } from '../../../../assets/images/index';

const CalendarEventDay = ({
  className,
  dataEvent,
  eventDay,
  dateDay,
  onClick,
  id,
  transform,
  transition,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onTransitionEnd,
  handleEventSelection,
  showEventDetail
}) => (
  <StyledCalendarEvent
    transform={transform}
    transition={transition}
    id={id}
    className={`${className} event`}
    eventDay={eventDay}
    onTouchStart={onTouchStart}
    onTouchMove={onTouchMove}
    onTouchEnd={onTouchEnd}
    onTransitionEnd={onTransitionEnd}
  >
    <StyledCalendarEventDate className="event-date">
      <StyledDragIcon className="event-drag" />
      <div>
        <StyledDateDayMonth date={dateDay}>
          <div>
            <StyledDayNumber date={dateDay} />
          </div>
          <StyledDateRight>
            <StyledMonth date={dateDay} />
            <StyledDayNumberNoDesktop date={dateDay} className="event-day" />
            <StyledDayText date={dateDay} />
          </StyledDateRight>
        </StyledDateDayMonth>
      </div>
      {!showEventDetail && (
        <StyledButtonToday onClick={onClick} className="event-today">
          {' '}
          HOY{' '}
        </StyledButtonToday>
      )}
    </StyledCalendarEventDate>
    {dataEvent ? (
      <StyledListEvent className="event-list">
        {dataEvent.map(item => (
          <StyledListEventItem
            key={`${item.id}`}
            onClick={() => handleEventSelection(item.id, dateDay)}
          >
            <StyledListEventName> {item.eventName} </StyledListEventName>
            {item.eventHour && (
              <div>
                {item.eventHour.map(item => (
                  <StyledListEventHours
                    key={`${item.eventHourStart}-${item.eventHourEnd}`}
                  >
                    {item.eventHourStart}
                    {' - '}
                    {item.eventHourEnd} hs.
                  </StyledListEventHours>
                ))}
              </div>
            )}
          </StyledListEventItem>
        ))}
      </StyledListEvent>
    ) : (
      <StyledCalendarEventNot className="event-nothing">
        No hay eventos para este día
        <StyleIconNotEvent
          size="l"
          color="light"
          svg={NotEvent}
          hover={false}
          className="event-nothing-icon"
        />
      </StyledCalendarEventNot>
    )}
  </StyledCalendarEvent>
);

CalendarEventDay.propTypes = {
  className: PropTypes.string,
  transform: PropTypes.number,
  transition: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  eventDay: PropTypes.bool,
  dateDay: PropTypes.string,
  onTouchStart: PropTypes.func,
  onTouchMove: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTransitionEnd: PropTypes.func,
  handleEventSelection: PropTypes.func,
  dataEvent: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      eventName: PropTypes.string,
      eventHour: PropTypes.arrayOf(
        PropTypes.shape({
          eventHourStart: PropTypes.string,
          eventHourEnd: PropTypes.string
        })
      )
    })
  )
};

CalendarEventDay.defaultProps = {
  eventDay: true
};

export default CalendarEventDay;
